import { Download } from "lucide-react";
import { PageLayout, PageTitle } from "../components/PageLayout";
import { forceDownload } from "../utils/download";

const ZIP_URL = `${process.env.PUBLIC_URL}/dist/raus-aus-dem-falschen-leben.zip`;

export default function BuildZip() {
  return (
    <PageLayout>
      <PageTitle testId="page-build-title">Build für IONOS</PageTitle>
      <div
        className="mx-auto mt-8 w-full max-w-3xl space-y-6 text-[16px] leading-[1.65]"
        style={{ color: "#1A1A1A" }}
      >
        <p>
          Hier kannst du die aktuelle Version der gesamten Website als ZIP-Datei
          herunterladen. Inhalt entpacken und per FileZilla in dein IONOS-Webroot
          hochladen.
        </p>
        <p
          className="text-sm"
          style={{ color: "rgba(26,26,26,0.6)" }}
        >
          Dateigröße: ca. 82 MB · enthält Code, alle Bilder (Wide/Atmos/Story/IST),
          Audio (DE + EN), PDFs, Impressum, Datenschutz.
        </p>

        <div className="mt-10 flex flex-col items-start gap-3">
          <button
            type="button"
            onClick={() =>
              forceDownload(ZIP_URL, "raus-aus-dem-falschen-leben.zip")
            }
            data-testid="download-build-zip"
            className="inline-flex items-center gap-3 transition-colors duration-200 hover:opacity-90"
            style={{
              backgroundColor: "#2A2624",
              color: "#FFFFFF",
              padding: "18px 28px",
              borderRadius: "8px",
              fontSize: "17px",
              fontWeight: 500,
              letterSpacing: "0.3px",
            }}
          >
            <Download className="h-6 w-6" />
            <span>ZIP herunterladen</span>
          </button>

          <a
            href={ZIP_URL}
            data-testid="download-build-zip-direct"
            className="text-sm underline transition-opacity duration-200 hover:opacity-70"
            style={{ color: "rgba(26,26,26,0.65)" }}
          >
            Alternativ: Direkter Link
          </a>
        </div>

        <div
          className="mt-12 rounded p-5"
          style={{
            backgroundColor: "rgba(42,38,36,0.05)",
            borderLeft: "3px solid #2A2624",
          }}
        >
          <h3
            className="text-[17px]"
            style={{ color: "#1A1A1A", fontWeight: 600 }}
          >
            Upload-Schritte
          </h3>
          <ol
            className="mt-3 list-decimal space-y-2 pl-5 text-[15px]"
            style={{ color: "rgba(26,26,26,0.85)" }}
          >
            <li>ZIP-Datei herunterladen und auf dem Rechner entpacken.</li>
            <li>
              Mit FileZilla per SFTP auf IONOS einloggen (Zugangsdaten in deinen
              IONOS-Unterlagen).
            </li>
            <li>
              <strong>Inhalt</strong> des entpackten Ordners (NICHT den Ordner
              selbst) in das Webroot hochladen — so dass <code>index.html</code>{" "}
              direkt im Hauptverzeichnis liegt.
            </li>
            <li>Bestehende Dateien überschreiben — fertig.</li>
          </ol>
        </div>
      </div>
    </PageLayout>
  );
}
